// content context keys
export const COUNTRY_CODE = 'CountryCode';
export const DEVICE = 'Device';
export const CUSTOMER_AUTH_STATE = 'CustomerAuthState';
export const VISITOR_STATUS = 'VisitorStatus';
export const GEOLOCATION_LOCAL_MARKET = 'GeolocationLocalMarket';
export const GEOLOCATION_STATE = 'GeolocationState';
export const ALL_US_LOCATIONS = 'AllUSLocations';

// display options sub-sections
export const CUSTOMER = 'Customer';
export const US_GEO_TARGETING = 'USGeoTargeting';
export const US_LOCAL_MARKET = 'USLocalMarket';
export const US_STATES = 'USStates';

// content context locations
export const METADATA_FIELDS_LOCATION = 'Payload.MetadataFields';
export const COUNTRY_CODE_LOCATION = 'ContentContext.CountryCode';
export const DEVICE_LOCATION = 'ContentContext.Device';
export const CUSTOMER_AUTH_STATE_LOCATION = 'ContentContext.CustomerAuthState';
export const VISITOR_STATUS_LOCATION = 'ContentContext.VisitorStatus';
export const GEOLOCATION_LOCAL_MARKET_LOCATION = 'ContentContext.GeolocationLocalMarket';
export const GEOLOCATION_STATE_LOCATION = 'ContentContext.GeolocationState';

// country codes
const INTERNATIONAL_COUNTRY_CODE = 'International';
export const US_COUNTRY_CODE = 'US';
const DEFAULT_COUNTRY_CODES = [US_COUNTRY_CODE, INTERNATIONAL_COUNTRY_CODE];

// devices
export const DISPLAY_ON_DESKTOP = 'Display On Desktop';
export const DISPLAY_ON_MOBILE = 'Display On Mobile';
export const DISPLAY_ON_APP_IOS = 'Display On iOS App';
export const DISPLAY_ON_APP_ANDROID = 'Display On Android App';
export const DISPLAY_ON_EMAIL = 'Display On Email';

// customer recognition
const UNRECOGNIZED_CUSTOMER = 'Anonymous';
const RECOGNIZED_CUSTOMER = 'Recognized';
const SIGNED_IN_CUSTOMER = 'Signed-In';
const CUSTOMER_AUTH_STATES = [UNRECOGNIZED_CUSTOMER, RECOGNIZED_CUSTOMER, SIGNED_IN_CUSTOMER];

// Visitor status (New (or) Repeat customer)
const NEW_CUSTOMER = 'New Customer';
const REPEAT_CUSTOMER = 'Repeat Customer';
const VISITOR_STATUS_VALUES = [NEW_CUSTOMER, REPEAT_CUSTOMER];

// geolocation
/* LA, NY, and SF listed as abbreviations to have parity with the Local API. and
'Washington' listed below in ALL_US_LOCAL_MARKETS represents Washington DC - but listed
as such to have parity with the Local API as well. */
export const ALL_US_LOCAL_MARKETS = [
  'Atlanta',
  'Austin',
  'Boston',
  'Chicago',
  'Dallas',
  'Denver',
  'Detroit',
  'Houston',
  'LA',
  'Miami',
  'Minneapolis',
  'NY',
  'Philadelphia',
  'Portland',
  'San Diego',
  'SF',
  'Seattle',
  'Washington DC'
];

export const ALL_US_STATES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Puerto Rico',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming'
];

export const SELECT_ALL = 'Select All';
export const SELECT_NONE = 'Select None';

export const DEFAULT_CONTENT_CONTEXT = {
  [COUNTRY_CODE]: DEFAULT_COUNTRY_CODES,
  [DEVICE]: [],
  [CUSTOMER_AUTH_STATE]: [],
  [VISITOR_STATUS]: [],
  [GEOLOCATION_LOCAL_MARKET]: [...ALL_US_LOCAL_MARKETS],
  [GEOLOCATION_STATE]: [...ALL_US_STATES]
};

export const SUPPORTED_CONTENT_CONTEXT = {
  [COUNTRY_CODE]: [US_COUNTRY_CODE, INTERNATIONAL_COUNTRY_CODE],
  [DEVICE]: [
    DISPLAY_ON_DESKTOP,
    DISPLAY_ON_MOBILE,
    DISPLAY_ON_APP_IOS,
    DISPLAY_ON_APP_ANDROID,
    DISPLAY_ON_EMAIL
  ],
  [CUSTOMER_AUTH_STATE]: CUSTOMER_AUTH_STATES,
  [VISITOR_STATUS]: VISITOR_STATUS_VALUES
};
